import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useI18n } from "@/i18n/I18nContext";

// Same official monogram used in the NavBar — keeps brand consistency.
const LOGO_MARK =
  "https://customer-assets.emergentagent.com/job_heritage-blend-4/artifacts/utpozekc_ER%20Logo.png";

export default function LoadingScreen() {
  const { t } = useI18n();
  const [done, setDone] = useState(false);
  const [pct, setPct] = useState(0);

  useEffect(() => {
    let value = 0;
    const interval = setInterval(() => {
      value += Math.random() * 9 + 4;
      if (value >= 100) {
        value = 100;
        clearInterval(interval);
        setTimeout(() => setDone(true), 600);
      }
      setPct(Math.floor(value));
    }, 110);
    return () => clearInterval(interval);
  }, []);

  return (
    <AnimatePresence>
      {!done && (
        <motion.div
          data-testid="loading-screen"
          className="fixed inset-0 z-[100] bg-pearl flex flex-col items-center justify-center"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 1.2, ease: [0.6, 0.01, 0.05, 0.95] }}
        >
          <div className="relative z-10 flex flex-col items-center gap-9 md:gap-10 px-8 text-center">
            <motion.img
              src={LOGO_MARK}
              alt="Ramirez"
              data-testid="loading-logo"
              className="h-20 md:h-28 w-auto select-none pointer-events-none"
              initial={{ opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1.4, ease: "easeOut" }}
            />
            <div className="font-mono text-[10px] tracking-widest2 uppercase text-tobacco/65">
              MMXLVIII · MCMXLVIII
            </div>
            <div className="font-display text-5xl md:text-7xl text-tobacco leading-[0.95] tracking-tight">
              {t("loading.label")}
            </div>
            <div className="font-mono text-[10px] tracking-widest2 uppercase text-tobacco/50">
              {t("loading.sub")}
            </div>
            <div className="w-[260px] md:w-[340px]">
              <div className="h-px bg-tobacco/25 relative overflow-hidden">
                <motion.div
                  className="absolute inset-y-0 left-0 bg-tobacco"
                  initial={{ width: 0 }}
                  animate={{ width: `${pct}%` }}
                  transition={{ duration: 0.4, ease: "linear" }}
                />
              </div>
              <div className="mt-4 flex items-center justify-between font-mono text-[10px] tracking-widest2 uppercase text-tobacco/50">
                <span>Loading</span>
                <span data-testid="loading-percent">{pct.toString().padStart(3, "0")}</span>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
